import PropTypes from 'prop-types';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';

// assets
import DownOutlined from '@ant-design/icons/DownOutlined';

// project import
import NavItem from './NavItem';
import NavSubGroup from './NavSubGroup';
import hasActiveChild from './hasActiveChild';
import { useGetMenuMaster } from 'api/menu';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

export default function NavGroup({ item }) {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const { pathname } = useLocation();

  const [open, setOpen] = useState(() => hasActiveChild(item.children, pathname));

  const navCollapse = item.children?.map((menuItem) => {
    switch (menuItem.type) {
      case 'collapse':
        return (
          <Typography key={menuItem.id} variant="caption" sx={{ p: 2.5, color: 'error.main' }}>
            collapse - only available in paid version
          </Typography>
        );
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={1} isTopLevel={!item.title} />;
      case 'subgroup':
        return <NavSubGroup key={menuItem.id} item={menuItem} />;
      default:
        return (
          <Typography key={menuItem.id} variant="h6" sx={{ color: 'error.main', textAlign: 'center' }}>
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  const GroupIcon = item.icon;
  const showHeader = Boolean(item.title) && drawerOpen;

  return (
    <List sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}>
      {showHeader && (
        <ListItemButton onClick={() => setOpen((prev) => !prev)} sx={{ pl: 3, pr: 2, py: 1, '&:hover': { bgcolor: 'primary.lighter' } }}>
          {GroupIcon && (
            <ListItemIcon sx={{ minWidth: 28, flexShrink: 0, color: 'text.secondary' }}>
              <GroupIcon style={{ fontSize: '1rem' }} />
            </ListItemIcon>
          )}
          <ListItemText
            sx={{ minWidth: 0 }}
            primary={
              <Typography
                variant="subtitle2"
                sx={{
                  color: 'text.secondary',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  fontSize: '0.75rem',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word'
                }}
              >
                {item.title}
              </Typography>
            }
          />
          <ListItemIcon sx={{ minWidth: 'auto', flexShrink: 0, ml: 0.5, color: 'text.secondary' }}>
            <DownOutlined
              style={{ fontSize: '0.7rem', transform: open ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 0.2s' }}
            />
          </ListItemIcon>
        </ListItemButton>
      )}
      {showHeader ? (
        <Collapse in={open} timeout="auto" unmountOnExit>
          {navCollapse}
        </Collapse>
      ) : (
        navCollapse
      )}
    </List>
  );
}

NavGroup.propTypes = { item: PropTypes.object };
